<template>
  <div class="login-main">
    <div class="public-width">
      <div class="logo-content clearfix">
        <div>
          <img
            src="https://imagessl.lingtuo.cn/A-1ed71af7_20250911144220.png"
            alt=""
          />
        </div>
        <strong>微脉水印相机 素材团队管理后台</strong>
      </div>

      <div class="login-page-main clearfix">
        <div class="login-left">
          <div class="login-l-01">
            <img
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20260209101952.png"
              alt=""
            />
          </div>
          <div class="login-l-02-text">
            <!-- <img
              src="https://imagessl.lingtuo.cn/A-1ed71af7_20250822171237.png"
              alt=""
            /> -->
            发布、编辑素材，支持定时发布
          </div>
        </div>
        <div class="login-right">
          <div class="login-box-shadow"></div>
          <div class="login-box-main">
            <div class="login-box-title">登录账号</div>
            <div class="login-box-type">
              <div v-on:click="changeLoginMode(0)">
                <img
                  :src="
                    loginIndex === 0
                      ? require('../assets/images/login-03-active.png')
                      : require('../assets/images/login-03.png')
                  "
                />扫码登录
              </div>
              <div style="color: #bdbdbd">|</div>
              <div v-on:click="changeLoginMode(1)">
                <img
                  :src="
                    loginIndex === 1
                      ? require('../assets/images/login-04-active.png')
                      : require('../assets/images/login-04.png')
                  "
                />手机号登录
              </div>
            </div>
            <div
              class="login-erweima"
              v-show="!isPhoneLogin"
            >
              <div class="login-ewm-title">使用微脉水印相机/微脉素材库</div>
              <div class="login-ewm-desc">（个人中心-右上角扫一扫）</div>
              <div class="login-ewm-code">
                <!-- <div id="qrcode"></div> -->
                <img
                  src=""
                  id="qrcode"
                />
              </div>
            </div>

            <div
              class="login-phonenum"
              v-show="isPhoneLogin"
            >
              <div class="login-pn-title">
                <input
                  type="text"
                  v-model="phoneNumber"
                  placeholder="请输入手机号"
                />
              </div>
              <div class="login-pn-desc clearfix">
                <div>验证码</div>
                <div>
                  <input
                    type="text"
                    placeholder="请输入验证码"
                    v-model="phoneYanzhengma"
                  />
                </div>
                <div
                  v-on:click="sendPhoneCode"
                  :class="{ huise: !yzmFlag }"
                >
                  {{ countNum }}
                </div>
              </div>
              <div
                class="login-pn-code"
                v-on:click="goHome"
              >
                {{ loginWord }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  name: "Login",
  data() {
    return {
      width:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      height:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
      loginWord: "登录",
      loginIndex: 1,
      loginTypeFlag: false,
      phoneNumber: "",
      phoneYanzhengma: "",
      yzmFlag: true,
      countTimer: null,
      countNum: "获取验证码",
      loginFlag: true,
      isPhoneLogin: false,
    };
  },
  components: {},
  mounted() {
    let _this = this;
    window.onresize = () => {
      return (() => {
        _this.width =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
        _this.height =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;
      })();
    };
  },
  async created() {
    console.log("login created...");

    if (localStorage.getItem("edujia:group:web:token")) {
      this.$store.commit(
        "modifyToken",
        localStorage.getItem("edujia:group:web:token"),
      );
      this.$router.push({ name: "whome" });
    } else {
      await this.getMtCode();
    }
  },
  methods: {
    changeLoginMode(mode) {
      this.isPhoneLogin = mode;
    },
    clearLocalStong() {
      window.localStorage.clear();
    },
    setLocalStong(
      wsid,
      nickname,
      faceIcon,
      token,
      key,
      kiVipExpireTime,
      isVip,
      isGroupVip,
    ) {
      localStorage.setItem("edujia:group:web:userid", wsid);
      localStorage.setItem("edujia:group:web:userName", nickname);
      localStorage.setItem("edujia:group:web:faceIcon", faceIcon);
      localStorage.setItem("edujia:group:web:token", token);
      localStorage.setItem("edujia:group:web:key", key);
      localStorage.setItem("edujia:group:web:kiVipExpireTime", kiVipExpireTime);
      localStorage.setItem("edujia:group:web:isVip", isVip);
      localStorage.setItem("edujia:group:web:isGroupVip", isGroupVip);
      localStorage.setItem(
        "edujia:group:web:kv",
        this.$common.encrypt(isVip, this.$store.state.lk),
      );
    },
    async getTwoCode(text) {
      try {
        return await QRCode.toDataURL(text, {
          errorCorrectionLevel: "H",
          type: "image/png",
          quality: 0.3,
          margin: 2,
          width: 151,
          color: {
            dark: "#000000ff",
            light: "#ffffffff",
          },
        });
      } catch (err) {
        console.error(err);
      }
    },
    async goHome() {
      if (this.loginFlag) {
        let myreg = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (this.phoneNumber === "") {
          this.$toast("手机号码不能为空", "", "取消", "删除", false);
        } else {
          if (myreg.test(this.phoneNumber)) {
            if (this.phoneYanzhengma === "") {
              this.$toast("验证码不能为空", "", "取消", "删除", false);
            } else {
              this.clearLocalStong();
              this.loginWord = "请稍后...";
              this.loginFlag = false;
              let params = {
                phone: Number(this.phoneNumber),
                vcode: Number(this.phoneYanzhengma),
              };
              let login = await this.$http.getLoginCode(params);
              //console.log(telLogin)
              if (login.code === 200) {
                let reallg = JSON.parse(
                  this.$common.decrypt(login.data, this.$config.ak),
                );
                reallg.object.token = this.$common.decrypt(
                  reallg.object.token,
                  reallg.object.key,
                );
                sessionStorage.setItem("navIndex", 2);
                this.$store.commit("updateState", reallg.object);
                //await sessionStorage.setItem("store",JSON.stringify(this.$store.state))
                this.$store.commit("modifyToken", reallg.object.token);
                this.setLocalStong(
                  reallg.object.wsid,
                  reallg.object.nickname,
                  reallg.object.faceIcon,
                  reallg.object.token,
                  reallg.object.key,
                  reallg.object.kiVipExpireTime,
                  reallg.object.isVip,
                  reallg.object.isGroupVip,
                );
                this.$router.push({ name: "whome" });
              } else {
                this.loginWord = "登录";
                // this.$toast(login.message,'','取消','删除',false)
              }
            }
            this.loginFlag = true;
          } else {
            this.$toast("手机号码错误，请重新填写", "", "取消", "删除", false);
          }
        }
      }
    },
    async sendPhoneCode() {
      if (this.yzmFlag) {
        let myreg = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (this.phoneNumber === "") {
          this.$toast("手机号码不能为空", "", "取消", "删除", false);
        } else {
          if (myreg.test(this.phoneNumber)) {
            let data = {
              phone: this.phoneNumber.trim(),
              time: new Date().getTime(),
            };
            let params = {
              phone: this.$common.encrypt(data, this.$config.ak),
            };
            console.log("params ==", params);
            let pc = await this.$http.sendMegCode(params);
            console.log(pc);
            if (pc.code === 200) {
              this.yzmFlag = false;
              this.countNum = 59;
              this.downCut();
            } else {
              // this.$toast(pc.message,'','取消','删除',false)
            }
          } else {
            this.$toast("手机号码错误，请重新填写", "", "取消", "删除", false);
          }
        }
      }
    },
    async getMtCode() {
      // let dataTo={
      //     token:this.$common.encrypt({time:new Date().getTime()},this.$config.ak)
      // }
      let dataTo = {
        token: this.$common.encrypt(
          { time: new Date().getTime() },
          this.$config.ak,
        ),
      };
      let qr = await this.$http.createQrCode(dataTo);
      let qrral = JSON.parse(this.$common.decrypt(qr.data, this.$config.ak));
      let obj = {
        app: "groupWeb",
        operation: "webLogin",
        code: qrral.object.clientId,
      };
      let codeUrl = await this.getTwoCode(JSON.stringify(obj));
      document.getElementById("qrcode").src = codeUrl;

      let content = await this.$common.connectMqtt(qrral);
      await this.getLoginCode(content);
    },
    async getLoginCode(str) {
      console.log("getLoginCode:str", str);
      var params = {
        encryptData: this.$common.encrypt(str, this.$config.ak),
      };
      let ral = await this.$http.loginByCode(params);
      let ewral = JSON.parse(this.$common.decrypt(ral.data, this.$config.ak));
      ewral.object.token = this.$common.decrypt(
        ewral.object.token,
        ewral.object.key,
      );
      sessionStorage.setItem("navIndex", 2);
      //await this.$store.commit("updateState",ewral.object)
      //await sessionStorage.setItem("store",JSON.stringify(this.$store.state))
      await this.setLocalStong(
        ewral.object.wsid,
        ewral.object.nickname,
        ewral.object.faceIcon,
        ewral.object.token,
        ewral.object.key,
        ewral.object.kiVipExpireTime,
        ewral.object.isVip,
        ewral.object.isGroupVip,
      );
      this.$router.push({ name: "whome" });
    },
    downCut() {
      let _this = this;
      clearInterval(_this.countTimer);
      this.countTimer = setInterval(function () {
        _this.countNum--;
        if (_this.countNum < 0) {
          _this.countNum = 0;
          _this.yzmFlag = true;
          _this.countNum = "获取验证码";
          clearInterval(_this.countTimer);
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.login-main {
  background-color: #fff9f9;
  background-image: url(../assets/images/beijing.png);
  background-position: center top;
  background-size: 100vw 100vh;
  width: 100vw;
  height: 100vh;
}
.logo-content {
  padding-top: 20px;
  -webkit-user-select: none;
  user-select: none;
}
.logo-content > div {
  float: left;
  width: 36px;
  height: 34px;
  padding-top: 2px;
  background-color: #ffffff;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  -webkit-box-shadow: 0 1px 9px 0 #fbdede;
  box-shadow: 0 1px 9px 0 #fbdede;
}
.logo-content div img {
  width: 32px;
  height: 32px;
  display: block;
  margin: auto;
}
.logo-content strong {
  float: left;
  font-size: 22px;
  line-height: 36px;
  color: #8f4d4a;
  padding-left: 8px;
}
.login-page-main {
  width: 1000px;
  margin: auto;
  padding-top: 162px;
}
.login-left {
  float: left;
  /* width: 413px; */
}
.login-l-01 {
  padding-top: 70px;
  -webkit-user-select: none;
  user-select: none;
}
.login-l-01 img {
  display: block;
  width: 420px;
}
.login-l-02 {
  padding-top: 10px;
  -webkit-user-select: none;
  user-select: none;
}
.login-l-02-text {
  font-size: 30px;
  line-height: 42px;
  font-weight: 500;
  margin-top: 24px;
  color: #e2606d;
}
.login-l-02 img {
  display: block;
  width: 510px;
  margin-top: 30px;
}
.login-right {
  float: right;
  width: 388px;
  position: relative;
}
.login-box-shadow {
  position: absolute;
  top: 27px;
  right: 0;
  width: 336px;
  height: 372px;
  background-color: rgba(255, 255, 255, 0.9);
  -webkit-border-radius: 21px;
  border-radius: 21px;
}
.login-box-main {
  position: relative;
  width: 359px;
  height: 364px;
  background-color: #ffffff;
  -webkit-border-radius: 21px;
  border-radius: 21px;
}
.login-box-title {
  text-align: center;
  font-size: 18px;
  line-height: 25px;
  padding-top: 20px;
  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
  font-weight: bold;
}

.login-box-type {
  height: 42px;
  background-color: #f5f5f6;
  margin-top: 20px;
}
.login-box-type > div {
  float: left;
  line-height: 42px;
  -webkit-user-select: none;
  user-select: none;
}
.login-box-type > div:first-child,
.login-box-type > div:last-child {
  width: 176px;
  text-align: center;
  cursor: pointer;
}
.login-box-type > div img {
  width: 18px;
  height: 18px;
  position: relative;
  top: 4px;
  margin-right: 3px;
}
.login-erweima {
  text-align: center;
}
.login-ewm-title {
  line-height: 20px;
  padding-top: 19px;
}
.login-ewm-desc {
  font-size: 12px;
  line-height: 17px;
  padding-top: 3px;
  color: #999999;
}
.login-ewm-code {
  width: 151px;
  padding-top: 14px;
  margin: auto;
}

.login-phonenum {
  padding-top: 32px;
  margin: 0 64px;
  font-size: 12px;
}
.login-pn-title input {
  font-size: 12px;
  width: 100%;
  height: 40px;
  background-color: #f5f6f6;
  padding-left: 10px;
  border: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.login-pn-desc {
  margin-top: 20px;
  background-color: #f5f6f6;
  height: 40px;
}
.login-pn-desc > div {
  float: left;
  line-height: 40px;
}
.login-pn-desc > div:nth-child(1) {
  font-size: 12px;
  width: 40px;
  padding-left: 10px;
  -webkit-user-select: none;
  user-select: none;
}
.login-pn-desc > div:nth-child(2) {
  width: 108px;
}
.login-pn-desc > div:nth-child(2) input {
  font-size: 12px;
  width: 100%;
  height: 40px;
  background-color: #f5f6f6;
  padding-left: 10px;
  border: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.login-pn-desc > div:nth-child(3) {
  font-size: 12px;
  width: 72px;
  background-color: #fb5d5c;
  text-align: center;
  color: #ffffff;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
}
.login-pn-desc > div:nth-child(3).huise {
  background-color: #999999;
}
.login-pn-code {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  background-color: #fb5d5c;
  color: #ffffff;
  text-align: center;
  margin-top: 30px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
}
</style>
